<template>
  <!-- <div class="container">
    <div class="row text-center">
      <div class="image-success"></div>
      <div class="col-md-8 col-md-offset-2 text-center">
        <h3>Your transaction is being processed</h3>
        <p class="text-center mb-20">
          Please check your transaction stored in <b>My Booking</b> menu
        </p>
        <div class="button-group">
          <a href="" class="btn btn-default"> Detail Transaction </a>
          <a href="" class="btn btn-primary"> Close </a>
        </div>
      </div>
      <div class="col-md-6 col-md-offset-3 hide">
        <div class="total-info">
          <h4>Total Bayar</h4>
          <div class="value-box">2.000.000<span class="currency">IDR</span></div>
        </div>
        <div class="payment-method mt-30">
          <h4>Metode Pembayaran</h4>
          <div class="value-box">
            <span class="img-master"></span>
            344543*****6543
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <BlockUI>
        <div class="container">
          <div class="row text-center">
            <!-- <div class="image-process" style="margin-top: 0;"></div> -->
            <div class="col-md-8 col-md-offset-2 text-center">
              <span class="underline-loader">
                <span style="font-size: 24px;font-weight: 500;line-height: 1.1;color: #333;">
                  Please wait
                </span>
              </span>
              <!-- <h4 class="mt-20">Your payment is being processed</h4> -->
            </div>
          </div>
        </div>
      </BlockUI>
</template>

<script>
export default {
  created() {
    const reservationId = this.$route.query.reservation_id;
    this.$router.push({ path: `/reservation/inquiry/${reservationId}` });
  },
};
</script>

<style scoped>
.underline-loader {
  color: #4FB848;
  font-weight: bold;
  font-size: 30px;
  padding:0 5px 15px 0;
  background:repeating-linear-gradient(90deg,currentColor 0 8%,#0000 0 10%) 200% 100%/200% 3px no-repeat;
  animation:c3 2s steps(6) infinite;
}
@keyframes c3 {to{background-position: 80% 100%}}
</style>



// WEBPACK FOOTER //
// src/components/payment/deposit/redirect.vue